import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

const resources = {
  en: {
    translation: {
      "Find your next stay": "Find your next stay",
      "Check availability": "Check availability",
      "Discover amazing places to stay in Amsterdam and surroundings": "Discover amazing places to stay in Amsterdam and surroundings",
      "of our accommodations on your desired dates": "of our accommodations on your desired dates",
      "Where are you going?": "Where are you going?",
      "Search": "Search",
      "Upcoming Events": "Upcoming Events",
      "All Listings": "All Listings",
      "Events & Attractions": "Events & Attractions",
      "Listings": "Listings",
      "Events": "Events",
      "Learn More": "Learn More",
      "Keukenhof Gardens": "Keukenhof Gardens",
      "Amsterdam Dance Event": "Amsterdam Dance Event",
      "Dutch F1 Grand Prix": "Dutch F1 Grand Prix",
      "Mysteryland": "Mysteryland",
      "Cozy Amsterdam Apartment": "Cozy Amsterdam Apartment",
      "Modern Haarlem House": "Modern Haarlem House",
      "Canal View Studio": "Canal View Studio",
      "Amsterdam Center": "Amsterdam Center",
      "Near Keukenhof": "Near Keukenhof",
      "Amsterdam": "Amsterdam",
      "night": "night",
      "Our Accommodations": "Our Accommodations",
      "Garden House": "Garden House",
      "Green Studio": "Green Studio",
      "Red Studio": "Red Studio",
      "Cozy house with beautiful garden terrace": "Cozy house with beautiful garden terrace",
      "Modern studio with terrace": "Modern studio with terrace",
      "Stylish studio with rooftop terrace": "Stylish studio with rooftop terrace",
      "Book directly via our booking platforms": "Book directly via our booking platforms",
      "Book Now": "Book Now",
      "Booking.com": "Booking.com",
      "Airbnb": "Airbnb",
      "slaapbank": "sofa bed",
      "sleutelkastje": "key box",
      "douche": "shower",
      "eethoek": "dining area",
      "keuken": "kitchen",
      "terras": "terrace",
      "slaapkamer": "bedroom",
      "voordeur": "front door",
      "bedden": "beds",
      "tv-en-kast": "tv and cabinet",
      "badkamerdeur": "bathroom door",
      "toilet": "toilet",
      "zithoek": "seating area",
      "uitzicht": "view",
      "zithoeka": "seating area",
      "terrasa": "terrace",
      "trapenvoordeur": "stairs front door",
      "dakterrasb": "rooftop terrace",
      "tvset": "tv set",
      "keukenkast": "kitchen cabinet",
      "uitzichta": "view",
      "Interesting places to visit": "Interesting places to visit",
      "Amsterdam City Center": "Amsterdam City Center",
      "Schiphol Airport": "Schiphol Airport",
      "Amsterdam beach (Zandvoort)": "Amsterdam beach (Zandvoort)",
      "Langevelderslag (Beach)": "Langevelderslag (Beach)",
      "Haarlem City Center": "Haarlem City Center",
      "Bergen (artist village)": "Bergen (artist village)",
      "The Bazaar Beverwijk": "The Bazaar Beverwijk",
      "Alkmaar Cheese": "Alkmaar Cheese",
      "Linneaushof Bennebroek": "Linneaushof Bennebroek",
      "During april and may": "During april and may",
      "Keukenhof": "Keukenhof",
      "Flowerbulb route": "Flowerbulb route",
      "Good to know": "Good to know",
      "Check-in & Check-out": "Check-in & Check-out",
      "Check-in: 15:00 - 22:00": "Check-in: From 2:00 PM",
      "Check-out: before 11:00": "Check-out: before 10:00 AM",
      "Self check-in with key box": "Self check-in with key box",
      "Late check-in possible (extra fee)": "Late check-in possible (extra fee)",
      "House Rules": "House Rules",
      "No smoking inside": "No smoking inside",
      "No parties or events": "No parties or events",
      "Quiet hours: 22:00 - 08:00": "Quiet hours: 22:00 - 08:00",
      "Maximum occupancy as listed": "Maximum occupancy as listed",
      "Transportation": "Transportation",
      "Free parking available": "Free parking available",
      "Bus stop 2 minutes walk": "Bus stop 2 minutes walk",
      "Train station 10 minutes": "Train station 10 minutes",
      "Amsterdam 20 minutes by train": "Amsterdam 20 minutes by train",
      "Amenities": "Amenities",
      "Free WiFi": "Free WiFi",
      "Fully equipped kitchen": "Fully equipped kitchen",
      "Washing machine": "Washing machine",
      "Fresh towels & linens": "Fresh towels & linens",
      "Local Tips": "Local Tips",
      "Supermarket 5 minutes walk": "Supermarket 5 minutes walk",
      "Restaurants nearby": "Restaurants nearby",
      "Beach 15 minutes by bike": "Beach 15 minutes by bike",
      "Bike rental available": "Bike rental available",
      "Emergency": "Emergency",
      "Emergency: 112": "Emergency: 112",
      "Police: 0900-8844": "Police: 0900-8844",
      "Host contact available 24/7": "Host contact available 24/7",
      "Hospital 10 minutes drive": "Hospital 10 minutes drive",
      "gardenhouse.title": "JaBaKi Garden House",
      "gardenhouse.description.title": "Description",
      "gardenhouse.description.text": "Nice renovated house, max 4 people. Near Amsterdam. Recently redecorated. Bathroom, bedroom and kitchen-living room. Shared use of outdoor kitchen and kids playground.",
      "gardenhouse.space.title": "The Space",
      "gardenhouse.space.text1": "A lovely detached garden house. Cozy kitchen-living room, bedroom and bathroom. The living room has a large sofa bed where 3 people can sit properly. This sofa bed offers 2 people the opportunity to sleep. Furthermore there is a single chair. A Samsung Smart TV is available with digital TV and basic Samsung Internet features.",
      "gardenhouse.space.text2": "The bedroom has two single beds that can be placed together or separate.",
      "gardenhouse.space.text3": "The bathroom has a toilet sink and rain shower.",
      "gardenhouse.space.text4": "The facade of the living room has a sliding window that you can easily open in nice weather set which gives an additional access to the shared garden.",
      "gardenhouse.space.text5": "In the garden is an outdoor kitchen, a sitting area and plenty of space. There are also garden facilities for children including a sandpit, trampoline and slide gazebo. For cooler evenings out there is an electric heating element.",
      "gardenhouse.access.title": "Guest Access",
      "gardenhouse.access.text": "The garden house has a private entrance which can be reached thru the driveway alongside and terrace after the house. In case of late arrival a locker is available to unlock a key.",
      "gardenhouse.neighborhood.title": "Neighborhood",
      "gardenhouse.neighborhood.text": "Throughout the year there are several fun events around Keukenhof, Mystery Land, Meerlive, Kingsday (27/4). Easy way out to visit Amsterdam and Haarlem. The North sea is easily accessible 20 km away. Additionally Hoofddorp has two parks: the Haarlemmermeersebos and Toolenburgseplas. Nearby are many restaurants and supermarkets. Look in the travelguide for many nice things in Hoofddorp and around.",
      "gardenhouse.children.title": "What to do for children in Hoofddorp?",
      "gardenhouse.children.item1": "Climbing for children at Klimpark 21. www.klimpark21.nl",
      "gardenhouse.children.item2": "Pick your own fruit. www.zelfplukken.nl",
      "gardenhouse.children.item3": "JumpXL Jump on a large zone of joined trampolines and air cushions www.jump-xl/nl/haarlemmermeer",
      "gardenhouse.children.item4": "De Boerenzwaluw, A paradise for animals and children. www.kinderboerderijdeboerenzwaluw.nl",
      "gardenhouse.children.item5": "Visit a working mill. www.eersteling.com",
      "gardenhouse.children.item6": "Outside Hoofddorp there is: Linneaushof . Europa's largest playground",
      "gardenhouse.children.item7": "Amsterdam: Nemo, Shipyard museum en Artis(zoo)",
      "gardenhouse.children.item8": "Zandvoort, the beach",
      "gardenhouse.transport.title": "Getting Around",
      "gardenhouse.transport.text": "The most up to date information can be found using gmaps selecting Jabaki Hoofddorp and any location you want as the two locations to travel between. Actual lines, time and prices for Public transport can be found by 9292.nl. This is a Dutch site for public transport.",
      "gardenhouse.checkin.title": "Check in and out",
      "gardenhouse.checkin.text": "Check in: 02:00 PM\nCheck out: 10:00 AM",
      "red-studio.title": "JaBaKi Red Studio",
      "red-studio.description.title": "Description",
      "red-studio.description.text": "Modern renovated studio, max 2 people. Near Amsterdam. Recently redecorated. Bathroom, bedroom and kitchen-living room.",
      "red-studio.space.title": "The Space",
      "red-studio.space.text1": "A lovely studio apartment. Cozy kitchen-living room, bedroom and bathroom. The room has a comfortable seating area. A TV is available with Google TV and basic Internet features (including Netflix, Spotify, TV Channels, YouTube, ..)",
      "red-studio.space.text2": "The studio has two comfortable separate single beds that are placed together (but can also be separated from each other).",
      "red-studio.space.text3": "The bathroom has a toilet, sink and rain shower.",
      "red-studio.space.text4": "The studio gives access to the 4-person seating area on the rooftop terrace. If desired, we can arrange for a BBQ.",
      "red-studio.space.text5": "",
      "red-studio.access.title": "Guest Access",
      "red-studio.access.text": "The red studio has a private entrance which can be reached via the stairs behind the house. In case of late arrival a key box is available with a key to unlock the door.",
      "red-studio.neighborhood.title": "Neighborhood",
      "red-studio.neighborhood.text": "Throughout the year there are several fun events around Keukenhof, Mystery Land, Meerlive, Kingsday (27/4). Easy way out to visit Amsterdam and Haarlem. The North sea is easily accessible 20 km away. Additionally Hoofddorp has two parks: the Haarlemmermeersebos and Toolenburgseplas. Nearby are many restaurants and supermarkets. Look in the travelguide for many nice things in Hoofddorp and around.",
      "red-studio.children.title": "What to do for children in Hoofddorp?",
      "red-studio.children.item1": "Climbing for children at Klimpark 21. www.klimpark21.nl",
      "red-studio.children.item2": "Pick your own fruit. www.zelfplukken.nl",
      "red-studio.children.item3": "JumpXL Jump on a large zone of joined trampolines and air cushions www.jump-xl/nl/haarlemmermeer",
      "red-studio.children.item4": "De Boerenzwaluw, A paradise for animals and children. www.kinderboerderijdeboerenzwaluw.nl",
      "red-studio.children.item5": "Visit a working mill. www.eersteling.com",
      "red-studio.children.item6": "Outside Hoofddorp there is: Linneaushof . Europa's largest playground",
      "red-studio.children.item7": "Amsterdam: Nemo, Shipyard museum en Artis(zoo)",
      "red-studio.children.item8": "Zandvoort, the beach",
      "red-studio.transport.title": "Getting Around",
      "red-studio.transport.text": "The most up to date information can be found using gmaps selecting Jabaki Hoofddorp and any location you want as the two locations to travel between. Actual lines, time and prices for Public transport can be found by 9292.nl. This is a Dutch site for public transport.",
      "red-studio.checkin.title": "Check in and out",
      "red-studio.checkin.text": "Check in: 02:00 PM\nCheck out: 10:00 AM",
      "green-studio.title": "JaBaKi Green Studio",
      "green-studio.description.title": "Description",
      "green-studio.description.text": "Modern renovated studio, max 2 people. Near Amsterdam. Recently redecorated. Bathroom, bedroom and kitchen-living room.",
      "green-studio.space.title": "The Space",
      "green-studio.space.text1": "A lovely detached studio apartment. Cozy kitchen-living room, bedroom and bathroom. The room has a comfortable seating area. A TV is available with Google TV and basic Internet features (including Netflix, Spotify, TV Channels, YouTube, ..)",
      "green-studio.space.text2": "The studio has a comfortable double box spring bed.",
      "green-studio.space.text3": "The bathroom has a toilet, sink and rain shower.",
      "green-studio.space.text4": "The studio gives access to the 4-person seating area in the front garden. If desired, we can arrange for a BBQ.",
      "green-studio.space.text5": "",
      "green-studio.access.title": "Guest Access",
      "green-studio.access.text": "The green studio has a private entrance which can be reached on the left side of the house. In case of late arrival a key box is available with a key to unlock the door.",
      "green-studio.neighborhood.title": "Neighborhood",
      "green-studio.neighborhood.text": "Throughout the year there are several fun events around Keukenhof, Mystery Land, Meerlive, Kingsday (27/4). Easy way out to visit Amsterdam and Haarlem. The North sea is easily accessible 20 km away. Additionally Hoofddorp has two parks: the Haarlemmermeersebos and Toolenburgseplas. Nearby are many restaurants and supermarkets. Look in the travelguide for many nice things in Hoofddorp and around.",
      "green-studio.children.title": "What to do for children in Hoofddorp?",
      "green-studio.children.item1": "Climbing for children at Klimpark 21. www.klimpark21.nl",
      "green-studio.children.item2": "Pick your own fruit. www.zelfplukken.nl",
      "green-studio.children.item3": "JumpXL Jump on a large zone of joined trampolines and air cushions www.jump-xl/nl/haarlemmermeer",
      "green-studio.children.item4": "De Boerenzwaluw, A paradise for animals and children. www.kinderboerderijdeboerenzwaluw.nl",
      "green-studio.children.item5": "Visit a working mill. www.eersteling.com",
      "green-studio.children.item6": "Outside Hoofddorp there is: Linneaushof . Europa's largest playground",
      "green-studio.children.item7": "Amsterdam: Nemo, Shipyard museum en Artis(zoo)",
      "green-studio.children.item8": "Zandvoort, the beach",
      "green-studio.transport.title": "Getting Around",
      "green-studio.transport.text": "The most up to date information can be found using gmaps selecting Jabaki Hoofddorp and any location you want as the two locations to travel between. Actual lines, time and prices for Public transport can be found by 9292.nl. This is a Dutch site for public transport.",
      "green-studio.checkin.title": "Check in and out",
      "green-studio.checkin.text": "Check in: 02:00 PM\nCheck out: 10:00 AM",
      "Terms and Conditions": "Terms and Conditions",
      "terms.title": "Terms and Conditions — JaBaKi Studios",
      "terms.subtitle": "(A Goodwin Solutions B.V. company, governed by Dutch law)",
      "terms.section1.title": "1. Terms and Definitions",
      "terms.section2.title": "2. Scope of the Agreement",
      "terms.section3.title": "3. Booking and Payment",
      "terms.section4.title": "4. Cancellation and Refunds",
      "terms.section5.title": "5. Guest Obligations",
      "terms.section6.title": "6. Host Obligations",
      "terms.section7.title": "7. Liability and Insurance",
      "terms.section8.title": "8. Force Majeure",
      "terms.section9.title": "9. Privacy",
      "terms.section10.title": "10. Applicable Law and Jurisdiction",
      "terms.section11.title": "11. Miscellaneous",
      "Restaurants & Cafés": "Restaurants & Cafés",
      "Supermarkets & Shops": "Supermarkets & Shops",
      "Attractions": "Attractions",
      "Entertainment": "Entertainment",
      "events.worldpride-2026.title": "WorldPride Amsterdam 2026",
      "events.worldpride-2026.date": "25 July - 8 August 2026",
      "events.worldpride-2026.location": "Amsterdam • Historic special edition",
      "events.worldpride-2026.details": "The world's biggest LGBTQ+ celebration comes to Amsterdam. Two weeks of events, demonstrations, and the iconic Canal Parade.",
      "events.worldpride-2026.button": "More info",
      "events.dahlia-2026.title": "Dahlia Festival Bollenstreek",
      "events.dahlia-2026.date": "1 August - 11 October 2026",
      "events.dahlia-2026.location": "Bollenstreek region",
      "events.dahlia-2026.details": "Beautiful dahlia show gardens",
      "events.dahlia-2026.button": "More info",
      "events.monumentendag-2026.title": "Open Monument Day",
      "events.monumentendag-2026.date": "12 & 13 September 2026",
      "events.monumentendag-2026.location": "Throughout the Netherlands",
      "events.monumentendag-2026.details": "Thousands of monuments open for free (40th edition)",
      "events.monumentendag-2026.button": "More info",
      "events.damtotdam-2026.title": "NN Dam tot Damloop",
      "events.damtotdam-2026.date": "19 & 20 September 2026",
      "events.damtotdam-2026.location": "Amsterdam - Zaandam",
      "events.damtotdam-2026.subtitle": "40th edition!",
      "events.damtotdam-2026.button": "More info",
      "events.marathon-2026.title": "TCS Amsterdam Marathon",
      "events.marathon-2026.date": "17 & 18 October 2026",
      "events.marathon-2026.location": "Amsterdam",
      "events.marathon-2026.subtitle": "50th edition!",
      "events.marathon-2026.button": "More info",
      "events.ade-2026.title": "Amsterdam Dance Event",
      "events.ade-2026.date": "21 - 25 October 2026",
      "events.ade-2026.location": "Amsterdam • World-leading",
      "events.ade-2026.subtitle": "30th anniversary!",
      "events.ade-2026.button": "More info",
      "events.keukenhof-2027.title": "Keukenhof Gardens",
      "events.keukenhof-2027.date": "18 March - 9 May 2027",
      "events.keukenhof-2027.location": "Lisse, South Holland",
      "events.keukenhof-2027.details": "World's largest flower garden with 7 million bulbs",
      "events.keukenhof-2027.button": "More info",
      "events.koningsdag-2027.title": "King's Day",
      "events.koningsdag-2027.date": "27 April 2027",
      "events.koningsdag-2027.location": "Throughout the Netherlands",
      "events.koningsdag-2027.details": "The biggest national holiday — street markets, live music, and orange everywhere",
      "events.koningsdag-2027.button": "More info",
      "events.pride-2027.title": "Amsterdam Pride",
      "events.pride-2027.date": "~31 July - 8 August 2027",
      "events.pride-2027.location": "Amsterdam",
      "events.pride-2027.button": "More info",
      "events.castlefest-2027.title": "Castlefest",
      "events.castlefest-2027.date": "5 - 8 August 2027",
      "events.castlefest-2027.location": "Lisse, Keukenhof Park",
      "events.castlefest-2027.details": "Fantasy, medieval, and Celtic music festival in the park",
      "events.castlefest-2027.button": "More info",
      "events.mysteryland-2027.title": "Mysteryland",
      "events.mysteryland-2027.date": "August 2027",
      "events.mysteryland-2027.location": "Haarlemmermeer",
      "events.mysteryland-2027.subtitle": "Returning after 2026 break!",
      "events.mysteryland-2027.button": "Pre-register",
      "events.dahlia-2027.title": "Dahlia Festival Bollenstreek",
      "events.dahlia-2027.date": "~August - October 2027",
      "events.dahlia-2027.location": "Bollenstreek region",
      "events.dahlia-2027.details": "Beautiful dahlia show gardens",
      "events.dahlia-2027.button": "More info",
      "events.monumentendag-2027.title": "Open Monument Day",
      "events.monumentendag-2027.date": "11 & 12 September 2027",
      "events.monumentendag-2027.location": "Throughout the Netherlands",
      "events.monumentendag-2027.details": "Thousands of monuments open for free",
      "events.monumentendag-2027.button": "More info",
      "events.damtotdam-2027.title": "NN Dam tot Damloop",
      "events.damtotdam-2027.date": "~18 & 19 September 2027",
      "events.damtotdam-2027.location": "Amsterdam - Zaandam",
      "events.damtotdam-2027.button": "More info",
      "events.marathon-2027.title": "TCS Amsterdam Marathon",
      "events.marathon-2027.date": "~17 October 2027",
      "events.marathon-2027.location": "Amsterdam",
      "events.marathon-2027.button": "More info",
      "events.ade-2027.title": "Amsterdam Dance Event",
      "events.ade-2027.date": "~October 2027",
      "events.ade-2027.location": "Amsterdam",
      "events.ade-2027.button": "More info"
    }
  },
  nl: {
    translation: {
      "Find your next stay": "Vind je volgende verblijf",
      "Check availability": "Bekijk beschikbaarheid",
      "Discover amazing places to stay in Amsterdam and surroundings": "Ontdek geweldige plekken om te verblijven in Amsterdam en omgeving",
      "of our accommodations on your desired dates": "van onze accommodaties op de gewenste data",
      "Where are you going?": "Waar ga je naartoe?",
      "Search": "Zoeken",
      "Upcoming Events": "Aankomende Evenementen",
      "All Listings": "Alle Accommodaties",
      "Events & Attractions": "Evenementen & Attracties",
      "Listings": "Accommodaties",
      "Events": "Evenementen",
      "Learn More": "Meer Info",
      "Keukenhof Gardens": "Keukenhof Tuinen",
      "Amsterdam Dance Event": "Amsterdam Dance Event",
      "Dutch F1 Grand Prix": "Nederlandse F1 Grand Prix",
      "Mysteryland": "Mysteryland",
      "Cozy Amsterdam Apartment": "Gezellig Amsterdam Appartement",
      "Modern Haarlem House": "Modern Haarlem Huis",
      "Canal View Studio": "Grachtzicht Studio",
      "Amsterdam Center": "Amsterdam Centrum",
      "Near Keukenhof": "Bij Keukenhof",
      "Amsterdam": "Amsterdam",
      "night": "nacht",
      "Our Accommodations": "Onze Accommodaties",
      "Garden House": "Tuinhuis",
      "Green Studio": "Groene Studio",
      "Red Studio": "Rode Studio",
      "Cozy house with beautiful garden terrace": "Gezellig huis met prachtig tuinterras",
      "Modern studio with terrace": "Moderne studio met terras",
      "Stylish studio with rooftop terrace": "Stijlvolle studio met dakterras",
      "Book directly via our booking platforms": "Boek direct via onze boekingsplatforms",
      "Book Now": "Boek Nu",
      "Booking.com": "Booking.com",
      "Airbnb": "Airbnb",
      "slaapbank": "slaapbank",
      "sleutelkastje": "sleutelkastje",
      "douche": "douche",
      "eethoek": "eethoek",
      "keuken": "keuken",
      "terras": "terras",
      "slaapkamer": "slaapkamer",
      "voordeur": "voordeur",
      "bedden": "bedden",
      "tv-en-kast": "tv en kast",
      "badkamerdeur": "badkamerdeur",
      "toilet": "toilet",
      "zithoek": "zithoek",
      "uitzicht": "uitzicht",
      "zithoeka": "zithoek",
      "terrasa": "terras",
      "trapenvoordeur": "trap voordeur",
      "dakterrasb": "dakterras",
      "tvset": "tv",
      "keukenkast": "keukenkast",
      "uitzichta": "uitzicht",
      "Interesting places to visit": "Interessante plaatsen om te bezoeken",
      "Amsterdam City Center": "Amsterdam Centrum",
      "Schiphol Airport": "Schiphol Luchthaven",
      "Amsterdam beach (Zandvoort)": "Amsterdam strand (Zandvoort)",
      "Langevelderslag (Beach)": "Langevelderslag (Strand)",
      "Haarlem City Center": "Haarlem Centrum",
      "Bergen (artist village)": "Bergen (kunstenaarsdorp)",
      "The Bazaar Beverwijk": "De Bazaar Beverwijk",
      "Alkmaar Cheese": "Alkmaar Kaas",
      "Linneaushof Bennebroek": "Linneaushof Bennebroek",
      "During april and may": "Tijdens april en mei",
      "Keukenhof": "Keukenhof",
      "Flowerbulb route": "Bloembollen route",
      "Good to know": "Goed om te weten",
      "Check-in & Check-out": "Inchecken & Uitchecken",
      "Check-in: 15:00 - 22:00": "Inchecken: Vanaf 14:00",
      "Check-out: before 11:00": "Uitchecken: voor 10:00 AM",
      "Self check-in with key box": "Zelf inchecken met sleutelkastje",
      "Late check-in possible (extra fee)": "Laat inchecken mogelijk (extra kosten)",
      "House Rules": "Huisregels",
      "No smoking inside": "Niet roken binnen",
      "No parties or events": "Geen feesten of evenementen",
      "Quiet hours: 22:00 - 08:00": "Stilte uren: 22:00 - 08:00",
      "Maximum occupancy as listed": "Maximale bezetting zoals vermeld",
      "Transportation": "Vervoer",
      "Free parking available": "Gratis parkeren beschikbaar",
      "Bus stop 2 minutes walk": "Bushalte 2 minuten lopen",
      "Train station 10 minutes": "Treinstation 10 minuten",
      "Amsterdam 20 minutes by train": "Amsterdam 20 minuten met de trein",
      "Amenities": "Voorzieningen",
      "Free WiFi": "Gratis WiFi",
      "Fully equipped kitchen": "Volledig uitgeruste keuken",
      "Washing machine": "Wasmachine",
      "Fresh towels & linens": "Schone handdoeken & beddengoed",
      "Local Tips": "Lokale Tips",
      "Supermarket 5 minutes walk": "Supermarkt 5 minuten lopen",
      "Restaurants nearby": "Restaurants in de buurt",
      "Beach 15 minutes by bike": "Strand 15 minuten fietsen",
      "Bike rental available": "Fietsverhuur beschikbaar",
      "Emergency": "Noodgeval",
      "Emergency: 112": "Noodgeval: 112",
      "Police: 0900-8844": "Politie: 0900-8844",
      "Host contact available 24/7": "Gastheer contact 24/7 beschikbaar",
      "Hospital 10 minutes drive": "Ziekenhuis 10 minuten rijden",
      "gardenhouse.title": "JaBaKi Tuinhuis",
      "gardenhouse.description.title": "Beschrijving",
      "gardenhouse.description.text": "Mooi gerenoveerd huis, max 4 personen. Nabij Amsterdam. Recent opnieuw ingericht. Badkamer, slaapkamer en keuken-woonkamer. Gedeeld gebruik van buitenkeuken en kinderspeelplaats.",
      "gardenhouse.space.title": "De Ruimte",
      "gardenhouse.space.text1": "Een heerlijk vrijstaand tuinhuis. Gezellige keuken-woonkamer, slaapkamer en badkamer. De woonkamer heeft een grote slaapbank waar 3 personen goed kunnen zitten. Deze slaapbank biedt 2 personen de mogelijkheid om te slapen. Verder is er een enkele stoel. Een Samsung Smart TV is beschikbaar met digitale TV en basis Samsung Internet functies.",
      "gardenhouse.space.text2": "De slaapkamer heeft twee eenpersoonsbedden die samen of apart geplaatst kunnen worden.",
      "gardenhouse.space.text3": "De badkamer heeft een toilet wastafel en regendouche.",
      "gardenhouse.space.text4": "De gevel van de woonkamer heeft een schuifraam dat je bij mooi weer gemakkelijk open kunt zetten wat een extra toegang geeft tot de gedeelde tuin.",
      "gardenhouse.space.text5": "In de tuin is een buitenkeuken, een zithoek en veel ruimte. Er zijn ook tuinfaciliteiten voor kinderen waaronder een zandbak, trampoline en glijbaan prieel. Voor koelere avonden buiten is er een elektrisch verwarmingselement.",
      "gardenhouse.access.title": "Gasttoegang",
      "gardenhouse.access.text": "Het tuinhuis heeft een eigen ingang die bereikbaar is via de oprit langs en terras achter het huis. Bij late aankomst is er een sleutelkastje beschikbaar om een sleutel te ontgrendelen.",
      "gardenhouse.neighborhood.title": "Buurt",
      "gardenhouse.neighborhood.text": "Het hele jaar door zijn er verschillende leuke evenementen rond Keukenhof, Mystery Land, Meerlive, Koningsdag (27/4). Gemakkelijke uitweg om Amsterdam en Haarlem te bezoeken. De Noordzee is gemakkelijk bereikbaar op 20 km afstand. Daarnaast heeft Hoofddorp twee parken: het Haarlemmermeersebos en Toolenburgseplas. In de buurt zijn veel restaurants en supermarkten. Kijk in de reisgids voor veel leuke dingen in Hoofddorp en omgeving.",
      "gardenhouse.children.title": "Wat te doen voor kinderen in Hoofddorp?",
      "gardenhouse.children.item1": "Klimmen voor kinderen bij Klimpark 21. www.klimpark21.nl",
      "gardenhouse.children.item2": "Zelf fruit plukken. www.zelfplukken.nl",
      "gardenhouse.children.item3": "JumpXL Spring op een grote zone van verbonden trampolines en luchtkussens www.jump-xl/nl/haarlemmermeer",
      "gardenhouse.children.item4": "De Boerenzwaluw, Een paradijs voor dieren en kinderen. www.kinderboerderijdeboerenzwaluw.nl",
      "gardenhouse.children.item5": "Bezoek een werkende molen. www.eersteling.com",
      "gardenhouse.children.item6": "Buiten Hoofddorp is er: Linneaushof . Europa's grootste speeltuin",
      "gardenhouse.children.item7": "Amsterdam: Nemo, Scheepvaartmuseum en Artis(dierentuin)",
      "gardenhouse.children.item8": "Zandvoort, het strand",
      "gardenhouse.transport.title": "Vervoer",
      "gardenhouse.transport.text": "De meest actuele informatie is te vinden met gmaps door Jabaki Hoofddorp en elke gewenste locatie te selecteren als de twee locaties om tussen te reizen. Actuele lijnen, tijd en prijzen voor openbaar vervoer zijn te vinden op 9292.nl. Dit is een Nederlandse site voor openbaar vervoer.",
      "gardenhouse.checkin.title": "In- en uitchecken",
      "gardenhouse.checkin.text": "Inchecken: 14:00\nUitchecken: 10:00",
      "red-studio.title": "JaBaKi Rode Studio",
      "red-studio.description.title": "Beschrijving",
      "red-studio.description.text": "Modern gerenoveerde studio, max 2 personen. Nabij Amsterdam. Recent opnieuw ingericht. Badkamer, slaapkamer en keuken-woonkamer.",
      "red-studio.space.title": "De Ruimte",
      "red-studio.space.text1": "Een heerlijk studio-appartement. Gezellige keuken-woonkamer, slaapkamer en badkamer. De kamer heeft een comfortabele zithoek. Een TV is beschikbaar met Google TV en basis Internet functies ( waaronder Netflix, Spotify, TV Zenders, YouTube, ..)",
      "red-studio.space.text2": "De Studio heeft twee comfortabel losse een persoons bedden die tegen elkaar staan (maar ook van elkaar af gezet kunnen worden).",
      "red-studio.space.text3": "De badkamer heeft een toilet, wastafel en regendouche.",
      "red-studio.space.text4": "De studio geeft toegang tot de 4 persoons zithoek op het dakterras. Indien gewenst kunnen we zorgen voor een BBQ.",
      "red-studio.space.text5": "",
      "red-studio.access.title": "Gasttoegang",
      "red-studio.access.text": "De rode studio heeft een eigen ingang die bereikbaar is via de trap achter het huis. Bij late aankomst is er een sleutelkastje beschikbaar met een sleutel om de deur te ontgrendelen.",
      "red-studio.neighborhood.title": "Buurt",
      "red-studio.neighborhood.text": "Het hele jaar door zijn er verschillende leuke evenementen rond Keukenhof, Mystery Land, Meerlive, Koningsdag (27/4). Gemakkelijke uitweg om Amsterdam en Haarlem te bezoeken. De Noordzee is gemakkelijk bereikbaar op 20 km afstand. Daarnaast heeft Hoofddorp twee parken: het Haarlemmermeersebos en Toolenburgseplas. In de buurt zijn veel restaurants en supermarkten. Kijk in de reisgids voor veel leuke dingen in Hoofddorp en omgeving.",
      "red-studio.children.title": "Wat te doen voor kinderen in Hoofddorp?",
      "red-studio.children.item1": "Klimmen voor kinderen bij Klimpark 21. www.klimpark21.nl",
      "red-studio.children.item2": "Zelf fruit plukken. www.zelfplukken.nl",
      "red-studio.children.item3": "JumpXL Spring op een grote zone van verbonden trampolines en luchtkussens www.jump-xl/nl/haarlemmermeer",
      "red-studio.children.item4": "De Boerenzwaluw, Een paradijs voor dieren en kinderen. www.kinderboerderijdeboerenzwaluw.nl",
      "red-studio.children.item5": "Bezoek een werkende molen. www.eersteling.com",
      "red-studio.children.item6": "Buiten Hoofddorp is er: Linneaushof . Europa's grootste speeltuin",
      "red-studio.children.item7": "Amsterdam: Nemo, Scheepvaartmuseum en Artis(dierentuin)",
      "red-studio.children.item8": "Zandvoort, het strand",
      "red-studio.transport.title": "Vervoer",
      "red-studio.transport.text": "De meest actuele informatie is te vinden met gmaps door Jabaki Hoofddorp en elke gewenste locatie te selecteren als de twee locaties om tussen te reizen. Actuele lijnen, tijd en prijzen voor openbaar vervoer zijn te vinden op 9292.nl. Dit is een Nederlandse site voor openbaar vervoer.",
      "red-studio.checkin.title": "In- en uitchecken",
      "red-studio.checkin.text": "Inchecken: 14:00\nUitchecken: 10:00",
      "green-studio.title": "JaBaKi Groene Studio",
      "green-studio.description.title": "Beschrijving",
      "green-studio.description.text": "Modern gerenoveerde studio, max 2 personen. Nabij Amsterdam. Recent opnieuw ingericht. Badkamer, slaapkamer en keuken-woonkamer.",
      "green-studio.space.title": "De Ruimte",
      "green-studio.space.text1": "Een heerlijke vrijstaande studio-appartement. Gezellige keuken-woonkamer, slaapkamer en badkamer. De kamer heeft een comfortabele zithoek. Een TV is beschikbaar met Google TV en basis Internet functies ( waaronder Netflix, Spotify, TV Zenders, YouTube, ..)",
      "green-studio.space.text2": "De Studio heeft een comfortabel tweepersoons boxpring.",
      "green-studio.space.text3": "De badkamer heeft een toilet, wastafel en regendouche.",
      "green-studio.space.text4": "De studio geeft toegang tot de 4 persoons zithoek in de voortuin. Indien gewenst kunnen we zorgen voor een BBQ.",
      "green-studio.space.text5": "",
      "green-studio.access.title": "Gasttoegang",
      "green-studio.access.text": "De groene studio heeft een eigen ingang die bereikbaar is aan de linkerzijde van het huis. Bij late aankomst is er een sleutelkastje beschikbaar met een sleutel om de deur te ontgrendelen.",
      "green-studio.neighborhood.title": "Buurt",
      "green-studio.neighborhood.text": "Het hele jaar door zijn er verschillende leuke evenementen rond Keukenhof, Mystery Land, Meerlive, Koningsdag (27/4). Gemakkelijke uitweg om Amsterdam en Haarlem te bezoeken. De Noordzee is gemakkelijk bereikbaar op 20 km afstand. Daarnaast heeft Hoofddorp twee parken: het Haarlemmermeersebos en Toolenburgseplas. In de buurt zijn veel restaurants en supermarkten. Kijk in de reisgids voor veel leuke dingen in Hoofddorp en omgeving.",
      "green-studio.children.title": "Wat te doen voor kinderen in Hoofddorp?",
      "green-studio.children.item1": "Klimmen voor kinderen bij Klimpark 21. www.klimpark21.nl",
      "green-studio.children.item2": "Zelf fruit plukken. www.zelfplukken.nl",
      "green-studio.children.item3": "JumpXL Spring op een grote zone van verbonden trampolines en luchtkussens www.jump-xl/nl/haarlemmermeer",
      "green-studio.children.item4": "De Boerenzwaluw, Een paradijs voor dieren en kinderen. www.kinderboerderijdeboerenzwaluw.nl",
      "green-studio.children.item5": "Bezoek een werkende molen. www.eersteling.com",
      "green-studio.children.item6": "Buiten Hoofddorp is er: Linneaushof . Europa's grootste speeltuin",
      "green-studio.children.item7": "Amsterdam: Nemo, Scheepvaartmuseum en Artis(dierentuin)",
      "green-studio.children.item8": "Zandvoort, het strand",
      "green-studio.transport.title": "Vervoer",
      "green-studio.transport.text": "De meest actuele informatie is te vinden met gmaps door Jabaki Hoofddorp en elke gewenste locatie te selecteren als de twee locaties om tussen te reizen. Actuele lijnen, tijd en prijzen voor openbaar vervoer zijn te vinden op 9292.nl. Dit is een Nederlandse site voor openbaar vervoer.",
      "green-studio.checkin.title": "In- en uitchecken",
      "green-studio.checkin.text": "Inchecken: 14:00\nUitchecken: 10:00",
      "Terms and Conditions": "Algemene Voorwaarden",
      "terms.title": "Algemene Voorwaarden — JaBaKi Studios",
      "terms.subtitle": "(Een Goodwin Solutions B.V. bedrijf, onder Nederlands recht)",
      "terms.section1.title": "1. Begrippen en Definities",
      "terms.section2.title": "2. Reikwijdte van de Overeenkomst",
      "terms.section3.title": "3. Boeking en Betaling",
      "terms.section4.title": "4. Annulering en Terugbetalingen",
      "terms.section5.title": "5. Verplichtingen van de Gast",
      "terms.section6.title": "6. Verplichtingen van de Gastheer",
      "terms.section7.title": "7. Aansprakelijkheid en Verzekering",
      "terms.section8.title": "8. Overmacht",
      "terms.section9.title": "9. Privacy",
      "terms.section10.title": "10. Toepasselijk Recht en Jurisdictie",
      "terms.section11.title": "11. Overige Bepalingen",
      "Restaurants & Cafés": "Restaurants & Cafés",
      "Supermarkets & Shops": "Supermarkten & Winkels",
      "Attractions": "Bezienswaardigheden",
      "Entertainment": "Uitgaan & Entertainment",
      "events.worldpride-2026.title": "WorldPride Amsterdam 2026",
      "events.worldpride-2026.date": "25 juli t/m 8 augustus 2026",
      "events.worldpride-2026.location": "Amsterdam • Historische speciale editie",
      "events.worldpride-2026.details": "Het grootste LGBTQ+ evenement ter wereld komt naar Amsterdam. Twee weken vol evenementen, demonstraties en de iconische Canal Parade.",
      "events.worldpride-2026.button": "Meer info",
      "events.dahlia-2026.title": "Dahlia Festival Bollenstreek",
      "events.dahlia-2026.date": "1 augustus - 11 oktober 2026",
      "events.dahlia-2026.location": "Bollenstreek",
      "events.dahlia-2026.details": "Prachtige dahlia showtuinen",
      "events.dahlia-2026.button": "Meer info",
      "events.monumentendag-2026.title": "Open Monumentendag",
      "events.monumentendag-2026.date": "12 & 13 september 2026",
      "events.monumentendag-2026.location": "Door heel Nederland",
      "events.monumentendag-2026.details": "Duizenden monumenten gratis toegankelijk (40e editie)",
      "events.monumentendag-2026.button": "Meer info",
      "events.damtotdam-2026.title": "NN Dam tot Damloop",
      "events.damtotdam-2026.date": "19 & 20 september 2026",
      "events.damtotdam-2026.location": "Amsterdam - Zaandam",
      "events.damtotdam-2026.subtitle": "40e editie!",
      "events.damtotdam-2026.button": "Meer info",
      "events.marathon-2026.title": "TCS Amsterdam Marathon",
      "events.marathon-2026.date": "17 & 18 oktober 2026",
      "events.marathon-2026.location": "Amsterdam",
      "events.marathon-2026.subtitle": "50e editie!",
      "events.marathon-2026.button": "Meer info",
      "events.ade-2026.title": "Amsterdam Dance Event",
      "events.ade-2026.date": "21 - 25 oktober 2026",
      "events.ade-2026.location": "Amsterdam • Wereldwijd toonaangevend",
      "events.ade-2026.subtitle": "30-jarig jubileum!",
      "events.ade-2026.button": "Meer info",
      "events.keukenhof-2027.title": "Keukenhof Tuinen",
      "events.keukenhof-2027.date": "18 maart - 9 mei 2027",
      "events.keukenhof-2027.location": "Lisse, Zuid-Holland",
      "events.keukenhof-2027.details": "'s Werelds grootste bloementuin met 7 miljoen bollen",
      "events.keukenhof-2027.button": "Meer info",
      "events.koningsdag-2027.title": "Koningsdag",
      "events.koningsdag-2027.date": "27 april 2027",
      "events.koningsdag-2027.location": "Door heel Nederland",
      "events.koningsdag-2027.details": "De grootste nationale feestdag — vrijmarkten, live muziek en overal oranje",
      "events.koningsdag-2027.button": "Meer info",
      "events.pride-2027.title": "Amsterdam Pride",
      "events.pride-2027.date": "~31 juli - 8 augustus 2027",
      "events.pride-2027.location": "Amsterdam",
      "events.pride-2027.button": "Meer info",
      "events.castlefest-2027.title": "Castlefest",
      "events.castlefest-2027.date": "5 - 8 augustus 2027",
      "events.castlefest-2027.location": "Lisse, Keukenhof Park",
      "events.castlefest-2027.details": "Fantasy, middeleeuws en Keltisch muziekfestival in het park",
      "events.castlefest-2027.button": "Meer info",
      "events.mysteryland-2027.title": "Mysteryland",
      "events.mysteryland-2027.date": "Augustus 2027",
      "events.mysteryland-2027.location": "Haarlemmermeer",
      "events.mysteryland-2027.subtitle": "Terug na pauze in 2026!",
      "events.mysteryland-2027.button": "Pre-registreren",
      "events.dahlia-2027.title": "Dahlia Festival Bollenstreek",
      "events.dahlia-2027.date": "~Augustus - oktober 2027",
      "events.dahlia-2027.location": "Bollenstreek",
      "events.dahlia-2027.details": "Prachtige dahlia showtuinen",
      "events.dahlia-2027.button": "Meer info",
      "events.monumentendag-2027.title": "Open Monumentendag",
      "events.monumentendag-2027.date": "11 & 12 september 2027",
      "events.monumentendag-2027.location": "Door heel Nederland",
      "events.monumentendag-2027.details": "Duizenden monumenten gratis toegankelijk",
      "events.monumentendag-2027.button": "Meer info",
      "events.damtotdam-2027.title": "NN Dam tot Damloop",
      "events.damtotdam-2027.date": "~18 & 19 september 2027",
      "events.damtotdam-2027.location": "Amsterdam - Zaandam",
      "events.damtotdam-2027.button": "Meer info",
      "events.marathon-2027.title": "TCS Amsterdam Marathon",
      "events.marathon-2027.date": "~17 oktober 2027",
      "events.marathon-2027.location": "Amsterdam",
      "events.marathon-2027.button": "Meer info",
      "events.ade-2027.title": "Amsterdam Dance Event",
      "events.ade-2027.date": "~Oktober 2027",
      "events.ade-2027.location": "Amsterdam",
      "events.ade-2027.button": "Meer info"
    }
  },
  de: {
    translation: {
      "Find your next stay": "Finden Sie Ihren nächsten Aufenthalt",
      "Check availability": "Verfügbarkeit prüfen",
      "Discover amazing places to stay in Amsterdam and surroundings": "Entdecken Sie tolle Unterkünfte in Amsterdam und Umgebung",
      "of our accommodations on your desired dates": "unserer Unterkünfte an Ihren gewünschten Terminen",
      "Where are you going?": "Wohin reisen Sie?",
      "Search": "Suchen",
      "Upcoming Events": "Kommende Veranstaltungen",
      "All Listings": "Alle Unterkünfte",
      "Events & Attractions": "Veranstaltungen & Attraktionen",
      "Listings": "Unterkünfte",
      "Events": "Veranstaltungen",
      "Learn More": "Mehr erfahren",
      "Keukenhof Gardens": "Keukenhof Gärten",
      "Amsterdam Dance Event": "Amsterdam Dance Event",
      "Dutch F1 Grand Prix": "Niederländischer F1 Grand Prix",
      "Mysteryland": "Mysteryland",
      "Cozy Amsterdam Apartment": "Gemütliche Amsterdam Wohnung",
      "Modern Haarlem House": "Modernes Haarlem Haus",
      "Canal View Studio": "Grachtenblick Studio",
      "Amsterdam Center": "Amsterdam Zentrum",
      "Near Keukenhof": "Nähe Keukenhof",
      "Amsterdam": "Amsterdam",
      "night": "Nacht",
      "Our Accommodations": "Unsere Unterkünfte",
      "Garden House": "Gartenhaus",
      "Green Studio": "Grünes Studio",
      "Red Studio": "Rotes Studio",
      "Cozy house with beautiful garden terrace": "Gemütliches Haus mit schöner Gartenterrasse",
      "Modern studio with terrace": "Modernes Studio mit Terrasse",
      "Stylish studio with rooftop terrace": "Stilvolles Studio mit Dachterrasse",
      "Book directly via our booking platforms": "Buchen Sie direkt über unsere Buchungsplattformen",
      "Book Now": "Jetzt buchen",
      "Booking.com": "Booking.com",
      "Airbnb": "Airbnb",
      "slaapbank": "Schlafsofa",
      "sleutelkastje": "Schlüsseltresor",
      "douche": "Dusche",
      "eethoek": "Essbereich",
      "keuken": "Küche",
      "terras": "Terrasse",
      "slaapkamer": "Schlafzimmer",
      "voordeur": "Eingangstür",
      "bedden": "Betten",
      "tv-en-kast": "TV und Schrank",
      "badkamerdeur": "Badezimmertür",
      "toilet": "Toilette",
      "zithoek": "Sitzecke",
      "uitzicht": "Aussicht",
      "zithoeka": "Sitzecke",
      "terrasa": "Terrasse",
      "trapenvoordeur": "Treppe Eingangstür",
      "dakterrasb": "Dachterrasse",
      "tvset": "Fernseher",
      "keukenkast": "Küchenschrank",
      "uitzichta": "Aussicht",
      "Interesting places to visit": "Interessante Orte zu besuchen",
      "Amsterdam City Center": "Amsterdam Stadtzentrum",
      "Schiphol Airport": "Flughafen Schiphol",
      "Amsterdam beach (Zandvoort)": "Amsterdam Strand (Zandvoort)",
      "Langevelderslag (Beach)": "Langevelderslag (Strand)",
      "Haarlem City Center": "Haarlem Stadtzentrum",
      "Bergen (artist village)": "Bergen (Künstlerdorf)",
      "The Bazaar Beverwijk": "Der Basar Beverwijk",
      "Alkmaar Cheese": "Alkmaar Käse",
      "Linneaushof Bennebroek": "Linneaushof Bennebroek",
      "During april and may": "Während April und Mai",
      "Keukenhof": "Keukenhof",
      "Flowerbulb route": "Blumenzwiebel Route",
      "Good to know": "Gut zu wissen",
      "Check-in & Check-out": "Ein- & Auschecken",
      "Check-in: 15:00 - 22:00": "Einchecken: Ab 14:00",
      "Check-out: before 11:00": "Auschecken: vor 10:00",
      "Self check-in with key box": "Selbst-Check-in mit Schlüsseltresor",
      "Late check-in possible (extra fee)": "Später Check-in möglich (Aufpreis)",
      "House Rules": "Hausregeln",
      "No smoking inside": "Nicht rauchen im Haus",
      "No parties or events": "Keine Partys oder Veranstaltungen",
      "Quiet hours: 22:00 - 08:00": "Ruhezeiten: 22:00 - 08:00",
      "Maximum occupancy as listed": "Maximale Belegung wie angegeben",
      "Transportation": "Transport",
      "Free parking available": "Kostenlose Parkplätze verfügbar",
      "Bus stop 2 minutes walk": "Bushaltestelle 2 Minuten zu Fuß",
      "Train station 10 minutes": "Bahnhof 10 Minuten",
      "Amsterdam 20 minutes by train": "Amsterdam 20 Minuten mit dem Zug",
      "Amenities": "Ausstattung",
      "Free WiFi": "Kostenloses WLAN",
      "Fully equipped kitchen": "Voll ausgestattete Küche",
      "Washing machine": "Waschmaschine",
      "Fresh towels & linens": "Frische Handtücher & Bettwäsche",
      "Local Tips": "Lokale Tipps",
      "Supermarket 5 minutes walk": "Supermarkt 5 Minuten zu Fuß",
      "Restaurants nearby": "Restaurants in der Nähe",
      "Beach 15 minutes by bike": "Strand 15 Minuten mit dem Fahrrad",
      "Bike rental available": "Fahrradverleih verfügbar",
      "Emergency": "Notfall",
      "Emergency: 112": "Notfall: 112",
      "Police: 0900-8844": "Polizei: 0900-8844",
      "Host contact available 24/7": "Gastgeber Kontakt 24/7 verfügbar",
      "Hospital 10 minutes drive": "Krankenhaus 10 Minuten Fahrt",
      "gardenhouse.title": "JaBaKi Gartenhaus",
      "gardenhouse.description.title": "Beschreibung",
      "gardenhouse.description.text": "Schön renoviertes Haus, max 4 Personen. Nähe Amsterdam. Kürzlich neu eingerichtet. Badezimmer, Schlafzimmer und Küche-Wohnzimmer. Gemeinsame Nutzung der Außenküche und des Kinderspielplatzes.",
      "gardenhouse.space.title": "Der Raum",
      "gardenhouse.space.text1": "Ein schönes freistehendes Gartenhaus. Gemütliche Küche-Wohnzimmer, Schlafzimmer und Badezimmer. Das Wohnzimmer hat ein großes Schlafsofa, auf dem 3 Personen bequem sitzen können. Dieses Schlafsofa bietet 2 Personen die Möglichkeit zu schlafen. Außerdem gibt es einen Einzelstuhl. Ein Samsung Smart TV ist verfügbar mit digitalem TV und grundlegenden Samsung Internet-Funktionen.",
      "gardenhouse.space.text2": "Das Schlafzimmer hat zwei Einzelbetten, die zusammen oder getrennt aufgestellt werden können.",
      "gardenhouse.space.text3": "Das Badezimmer hat ein Toiletten-Waschbecken und eine Regendusche.",
      "gardenhouse.space.text4": "Die Fassade des Wohnzimmers hat ein Schiebefenster, das Sie bei schönem Wetter leicht öffnen können, was einen zusätzlichen Zugang zum gemeinsamen Garten bietet.",
      "gardenhouse.space.text5": "Im Garten gibt es eine Außenküche, eine Sitzecke und viel Platz. Es gibt auch Garteneinrichtungen für Kinder, darunter ein Sandkasten, Trampolin und Rutsche-Pavillon. Für kühlere Abende draußen gibt es ein elektrisches Heizelement.",
      "gardenhouse.access.title": "Gastzugang",
      "gardenhouse.access.text": "Das Gartenhaus hat einen privaten Eingang, der über die Auffahrt entlang und Terrasse hinter dem Haus erreicht werden kann. Bei später Ankunft ist ein Schließfach verfügbar, um einen Schlüssel zu entsperren.",
      "gardenhouse.neighborhood.title": "Nachbarschaft",
      "gardenhouse.neighborhood.text": "Das ganze Jahr über gibt es verschiedene lustige Veranstaltungen rund um Keukenhof, Mystery Land, Meerlive, Königstag (27/4). Einfacher Weg, um Amsterdam und Haarlem zu besuchen. Die Nordsee ist leicht erreichbar, 20 km entfernt. Zusätzlich hat Hoofddorp zwei Parks: das Haarlemmermeersebos und Toolenburgseplas. In der Nähe sind viele Restaurants und Supermärkte. Schauen Sie im Reiseführer nach vielen schönen Dingen in Hoofddorp und Umgebung.",
      "gardenhouse.children.title": "Was können Kinder in Hoofddorp unternehmen?",
      "gardenhouse.children.item1": "Klettern für Kinder im Klimpark 21. www.klimpark21.nl",
      "gardenhouse.children.item2": "Selbst Obst pflücken. www.zelfplukken.nl",
      "gardenhouse.children.item3": "JumpXL Springen auf einer großen Zone verbundener Trampoline und Luftkissen www.jump-xl/nl/haarlemmermeer",
      "gardenhouse.children.item4": "De Boerenzwaluw, Ein Paradies für Tiere und Kinder. www.kinderboerderijdeboerenzwaluw.nl",
      "gardenhouse.children.item5": "Besuchen Sie eine funktionierende Mühle. www.eersteling.com",
      "gardenhouse.children.item6": "Außerhalb von Hoofddorp gibt es: Linneaushof . Europas größter Spielplatz",
      "gardenhouse.children.item7": "Amsterdam: Nemo, Schifffahrtsmuseum und Artis(Zoo)",
      "gardenhouse.children.item8": "Zandvoort, der Strand",
      "gardenhouse.transport.title": "Fortbewegung",
      "gardenhouse.transport.text": "Die aktuellsten Informationen finden Sie mit gmaps, indem Sie Jabaki Hoofddorp und jeden gewünschten Ort als die beiden Orte auswählen, zwischen denen Sie reisen möchten. Aktuelle Linien, Zeiten und Preise für öffentliche Verkehrsmittel finden Sie auf 9292.nl. Dies ist eine niederländische Website für öffentliche Verkehrsmittel.",
      "gardenhouse.checkin.title": "Ein- und Auschecken",
      "gardenhouse.checkin.text": "Einchecken: 14:00\nAuschecken: 10:00",
      "red-studio.title": "JaBaKi Rotes Studio",
      "red-studio.description.title": "Beschreibung",
      "red-studio.description.text": "Modern renoviertes Studio, max 2 Personen. Nähe Amsterdam. Kürzlich neu eingerichtet. Badezimmer, Schlafzimmer und Küche-Wohnzimmer.",
      "red-studio.space.title": "Der Raum",
      "red-studio.space.text1": "Ein schönes Studio-Apartment. Gemütliche Küche-Wohnzimmer, Schlafzimmer und Badezimmer. Das Zimmer hat eine komfortable Sitzecke. Ein TV ist verfügbar mit Google TV und grundlegenden Internet-Funktionen (einschließlich Netflix, Spotify, TV-Kanäle, YouTube, ..)",
      "red-studio.space.text2": "Das Studio hat zwei komfortable separate Einzelbetten, die zusammenstehen (aber auch voneinander getrennt werden können).",
      "red-studio.space.text3": "Das Badezimmer hat eine Toilette, Waschbecken und Regendusche.",
      "red-studio.space.text4": "Das Studio bietet Zugang zur 4-Personen-Sitzecke auf der Dachterrasse. Auf Wunsch können wir für einen Grill sorgen.",
      "red-studio.space.text5": "",
      "red-studio.access.title": "Gastzugang",
      "red-studio.access.text": "Das rote Studio hat einen privaten Eingang, der über die Treppe hinter dem Haus erreicht werden kann. Bei später Ankunft ist ein Schlüsselkasten verfügbar mit einem Schlüssel, um die Tür zu entsperren.",
      "red-studio.neighborhood.title": "Nachbarschaft",
      "red-studio.neighborhood.text": "Das ganze Jahr über gibt es verschiedene lustige Veranstaltungen rund um Keukenhof, Mystery Land, Meerlive, Königstag (27/4). Einfacher Weg, um Amsterdam und Haarlem zu besuchen. Die Nordsee ist leicht erreichbar, 20 km entfernt. Zusätzlich hat Hoofddorp zwei Parks: das Haarlemmermeersebos und Toolenburgseplas. In der Nähe sind viele Restaurants und Supermärkte. Schauen Sie im Reiseführer nach vielen schönen Dingen in Hoofddorp und Umgebung.",
      "red-studio.children.title": "Was können Kinder in Hoofddorp unternehmen?",
      "red-studio.children.item1": "Klettern für Kinder im Klimpark 21. www.klimpark21.nl",
      "red-studio.children.item2": "Selbst Obst pflücken. www.zelfplukken.nl",
      "red-studio.children.item3": "JumpXL Springen auf einer großen Zone verbundener Trampoline und Luftkissen www.jump-xl/nl/haarlemmermeer",
      "red-studio.children.item4": "De Boerenzwaluw, Ein Paradies für Tiere und Kinder. www.kinderboerderijdeboerenzwaluw.nl",
      "red-studio.children.item5": "Besuchen Sie eine funktionierende Mühle. www.eersteling.com",
      "red-studio.children.item6": "Außerhalb von Hoofddorp gibt es: Linneaushof . Europas größter Spielplatz",
      "red-studio.children.item7": "Amsterdam: Nemo, Schifffahrtsmuseum und Artis(Zoo)",
      "red-studio.children.item8": "Zandvoort, der Strand",
      "red-studio.transport.title": "Fortbewegung",
      "red-studio.transport.text": "Die aktuellsten Informationen finden Sie mit gmaps, indem Sie Jabaki Hoofddorp und jeden gewünschten Ort als die beiden Orte auswählen, zwischen denen Sie reisen möchten. Aktuelle Linien, Zeiten und Preise für öffentliche Verkehrsmittel finden Sie auf 9292.nl. Dies ist eine niederländische Website für öffentliche Verkehrsmittel.",
      "red-studio.checkin.title": "Ein- und Auschecken",
      "red-studio.checkin.text": "Einchecken: 14:00\nAuschecken: 10:00",
      "green-studio.title": "JaBaKi Grünes Studio",
      "green-studio.description.title": "Beschreibung",
      "green-studio.description.text": "Modern renoviertes Studio, max 2 Personen. Nähe Amsterdam. Kürzlich neu eingerichtet. Badezimmer, Schlafzimmer und Küche-Wohnzimmer.",
      "green-studio.space.title": "Der Raum",
      "green-studio.space.text1": "Ein schönes freistehendes Studio-Apartment. Gemütliche Küche-Wohnzimmer, Schlafzimmer und Badezimmer. Das Zimmer hat eine komfortable Sitzecke. Ein TV ist verfügbar mit Google TV und grundlegenden Internet-Funktionen (einschließlich Netflix, Spotify, TV-Kanäle, YouTube, ..)",
      "green-studio.space.text2": "Das Studio hat ein komfortables Doppel-Boxspringbett.",
      "green-studio.space.text3": "Das Badezimmer hat eine Toilette, Waschbecken und Regendusche.",
      "green-studio.space.text4": "Das Studio bietet Zugang zur 4-Personen-Sitzecke im Vorgarten. Auf Wunsch können wir für einen Grill sorgen.",
      "green-studio.space.text5": "",
      "green-studio.access.title": "Gastzugang",
      "green-studio.access.text": "Das grüne Studio hat einen privaten Eingang, der an der linken Seite des Hauses erreicht werden kann. Bei später Ankunft ist ein Schlüsselkasten verfügbar mit einem Schlüssel, um die Tür zu entsperren.",
      "green-studio.neighborhood.title": "Nachbarschaft",
      "green-studio.neighborhood.text": "Das ganze Jahr über gibt es verschiedene lustige Veranstaltungen rund um Keukenhof, Mystery Land, Meerlive, Königstag (27/4). Einfacher Weg, um Amsterdam und Haarlem zu besuchen. Die Nordsee ist leicht erreichbar, 20 km entfernt. Zusätzlich hat Hoofddorp zwei Parks: das Haarlemmermeersebos und Toolenburgseplas. In der Nähe sind viele Restaurants und Supermärkte. Schauen Sie im Reiseführer nach vielen schönen Dingen in Hoofddorp und Umgebung.",
      "green-studio.children.title": "Was können Kinder in Hoofddorp unternehmen?",
      "green-studio.children.item1": "Klettern für Kinder im Klimpark 21. www.klimpark21.nl",
      "green-studio.children.item2": "Selbst Obst pflücken. www.zelfplukken.nl",
      "green-studio.children.item3": "JumpXL Springen auf einer großen Zone verbundener Trampoline und Luftkissen www.jump-xl/nl/haarlemmermeer",
      "green-studio.children.item4": "De Boerenzwaluw, Ein Paradies für Tiere und Kinder. www.kinderboerderijdeboerenzwaluw.nl",
      "green-studio.children.item5": "Besuchen Sie eine funktionierende Mühle. www.eersteling.com",
      "green-studio.children.item6": "Außerhalb von Hoofddorp gibt es: Linneaushof . Europas größter Spielplatz",
      "green-studio.children.item7": "Amsterdam: Nemo, Schifffahrtsmuseum und Artis(Zoo)",
      "green-studio.children.item8": "Zandvoort, der Strand",
      "green-studio.transport.title": "Fortbewegung",
      "green-studio.transport.text": "Die aktuellsten Informationen finden Sie mit gmaps, indem Sie Jabaki Hoofddorp und jeden gewünschten Ort als die beiden Orte auswählen, zwischen denen Sie reisen möchten. Aktuelle Linien, Zeiten und Preise für öffentliche Verkehrsmittel finden Sie auf 9292.nl. Dies ist eine niederländische Website für öffentliche Verkehrsmittel.",
      "green-studio.checkin.title": "Ein- und Auschecken",
      "green-studio.checkin.text": "Einchecken: 14:00\nAuschecken: 10:00",
      "Terms and Conditions": "Allgemeine Geschäftsbedingungen",
      "terms.title": "Allgemeine Geschäftsbedingungen — JaBaKi Studios",
      "terms.subtitle": "(Ein Goodwin Solutions B.V. Unternehmen, unter niederländischem Recht)",
      "terms.section1.title": "1. Begriffe und Definitionen",
      "terms.section2.title": "2. Geltungsbereich der Vereinbarung",
      "terms.section3.title": "3. Buchung und Zahlung",
      "terms.section4.title": "4. Stornierung und Rückerstattungen",
      "terms.section5.title": "5. Gäste-Verpflichtungen",
      "terms.section6.title": "6. Gastgeber-Verpflichtungen",
      "terms.section7.title": "7. Haftung und Versicherung",
      "terms.section8.title": "8. Höhere Gewalt",
      "terms.section9.title": "9. Datenschutz",
      "terms.section10.title": "10. Anwendbares Recht und Gerichtsbarkeit",
      "terms.section11.title": "11. Sonstiges",
      "Restaurants & Cafés": "Restaurants & Cafés",
      "Supermarkets & Shops": "Supermärkte & Geschäfte",
      "Attractions": "Sehenswürdigkeiten",
      "Entertainment": "Unterhaltung",
      "events.worldpride-2026.title": "WorldPride Amsterdam 2026",
      "events.worldpride-2026.date": "25. Juli - 8. August 2026",
      "events.worldpride-2026.location": "Amsterdam • Historische Sonderausgabe",
      "events.worldpride-2026.details": "Die größte LGBTQ+ Feier der Welt kommt nach Amsterdam. Zwei Wochen voller Veranstaltungen, Demonstrationen und der ikonischen Canal Parade.",
      "events.worldpride-2026.button": "Mehr Infos",
      "events.dahlia-2026.title": "Dahlienfest Bollenstreek",
      "events.dahlia-2026.date": "1. August - 11. Oktober 2026",
      "events.dahlia-2026.location": "Region Bollenstreek",
      "events.dahlia-2026.details": "Wunderschöne Dahlien-Schaugärten",
      "events.dahlia-2026.button": "Mehr Infos",
      "events.monumentendag-2026.title": "Tag des offenen Denkmals",
      "events.monumentendag-2026.date": "12. & 13. September 2026",
      "events.monumentendag-2026.location": "In den ganzen Niederlanden",
      "events.monumentendag-2026.details": "Tausende Denkmäler kostenlos zugänglich (40. Ausgabe)",
      "events.monumentendag-2026.button": "Mehr Infos",
      "events.damtotdam-2026.title": "NN Dam tot Damloop",
      "events.damtotdam-2026.date": "19. & 20. September 2026",
      "events.damtotdam-2026.location": "Amsterdam - Zaandam",
      "events.damtotdam-2026.subtitle": "40. Ausgabe!",
      "events.damtotdam-2026.button": "Mehr Infos",
      "events.marathon-2026.title": "TCS Amsterdam Marathon",
      "events.marathon-2026.date": "17. & 18. Oktober 2026",
      "events.marathon-2026.location": "Amsterdam",
      "events.marathon-2026.subtitle": "50. Ausgabe!",
      "events.marathon-2026.button": "Mehr Infos",
      "events.ade-2026.title": "Amsterdam Dance Event",
      "events.ade-2026.date": "21. - 25. Oktober 2026",
      "events.ade-2026.location": "Amsterdam • Weltweit führend",
      "events.ade-2026.subtitle": "30-jähriges Jubiläum!",
      "events.ade-2026.button": "Mehr Infos",
      "events.keukenhof-2027.title": "Keukenhof Gärten",
      "events.keukenhof-2027.date": "18. März - 9. Mai 2027",
      "events.keukenhof-2027.location": "Lisse, Südholland",
      "events.keukenhof-2027.details": "Der weltgrößte Blumengarten mit 7 Millionen Zwiebeln",
      "events.keukenhof-2027.button": "Mehr Infos",
      "events.koningsdag-2027.title": "Königstag",
      "events.koningsdag-2027.date": "27. April 2027",
      "events.koningsdag-2027.location": "In den ganzen Niederlanden",
      "events.koningsdag-2027.details": "Der größte Nationalfeiertag — Flohmärkte, Live-Musik und überall Orange",
      "events.koningsdag-2027.button": "Mehr Infos",
      "events.pride-2027.title": "Amsterdam Pride",
      "events.pride-2027.date": "~31. Juli - 8. August 2027",
      "events.pride-2027.location": "Amsterdam",
      "events.pride-2027.button": "Mehr Infos",
      "events.castlefest-2027.title": "Castlefest",
      "events.castlefest-2027.date": "5. - 8. August 2027",
      "events.castlefest-2027.location": "Lisse, Keukenhof Park",
      "events.castlefest-2027.details": "Fantasy-, Mittelalter- und keltisches Musikfestival im Park",
      "events.castlefest-2027.button": "Mehr Infos",
      "events.mysteryland-2027.title": "Mysteryland",
      "events.mysteryland-2027.date": "August 2027",
      "events.mysteryland-2027.location": "Haarlemmermeer",
      "events.mysteryland-2027.subtitle": "Zurück nach Pause 2026!",
      "events.mysteryland-2027.button": "Vorregistrierung",
      "events.dahlia-2027.title": "Dahlienfest Bollenstreek",
      "events.dahlia-2027.date": "~August - Oktober 2027",
      "events.dahlia-2027.location": "Region Bollenstreek",
      "events.dahlia-2027.details": "Wunderschöne Dahlien-Schaugärten",
      "events.dahlia-2027.button": "Mehr Infos",
      "events.monumentendag-2027.title": "Tag des offenen Denkmals",
      "events.monumentendag-2027.date": "11. & 12. September 2027",
      "events.monumentendag-2027.location": "In den ganzen Niederlanden",
      "events.monumentendag-2027.details": "Tausende Denkmäler kostenlos zugänglich",
      "events.monumentendag-2027.button": "Mehr Infos",
      "events.damtotdam-2027.title": "NN Dam tot Damloop",
      "events.damtotdam-2027.date": "~18. & 19. September 2027",
      "events.damtotdam-2027.location": "Amsterdam - Zaandam",
      "events.damtotdam-2027.button": "Mehr Infos",
      "events.marathon-2027.title": "TCS Amsterdam Marathon",
      "events.marathon-2027.date": "~17. Oktober 2027",
      "events.marathon-2027.location": "Amsterdam",
      "events.marathon-2027.button": "Mehr Infos",
      "events.ade-2027.title": "Amsterdam Dance Event",
      "events.ade-2027.date": "~Oktober 2027",
      "events.ade-2027.location": "Amsterdam",
      "events.ade-2027.button": "Mehr Infos"
    }
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    detection: {
      order: ['navigator', 'htmlTag', 'path', 'subdomain'],
    },
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n